module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-25-bf8d3c5c478b61413f41badbdf6ca47a.png";